import React from 'react';
import {formatCurrency} from '../../utility/format-currency';
import {compose} from 'redux';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {firestoreConnect} from 'react-redux-firebase';
import {updateQuantity, vicousticAnonLocalCartKey} from '../../store/actions/cart-actions';
import OutsideClickHandler from 'react-outside-click-handler'
import { checkParent } from '../../utility/check-parent';
import { getLocalCart } from '../../utility/get-local-cart';

const getItemVariation = item => item.variates ? item.variates.map(v => item[v]).join(", ") : "";


const getCartTotal = items => items.reduce((acc, item) => acc + parseFloat(item.price) * parseInt(item.quantity), 0);


const MiniCart = props => {
	const onOutsideClick = (e) => {
		const button = document.querySelector('.cart-button')
		if (checkParent(button, e.target)) {
			return
		}
		props.close()
	}
	
	return (
		<OutsideClickHandler onOutsideClick={onOutsideClick}>
			<div className="menu-sidebar mini-cart">
				<div className="sidebar-title">
					<p className='h6'><b>My Basket</b></p>
				</div>
				<button className="sidebar-close" onClick={props.close}><i /></button>
				<div className="sidebar-wrapper">
					{props.items && props.items.length > 0 ? 
						(
							<React.Fragment>
								<ul className="cart-items">
									{props.items.map(item => (
										<li key={item.id}>
											<p className="product-title">{item.name}</p>
											<p className="product-variation-desc">{getItemVariation(item)}</p>
											<p className="product-quantity">{item.quantity} item{parseInt(item.quantity) > 1 ? "s" : ""}</p>
											{props.uid && <p className="product-price">{formatCurrency(parseFloat(item.price) * parseInt(item.quantity))}</p>}
											<button className="product-remove" onClick={() => props.updateQuantity(item, 0)}><i className="far fa-trash-alt"></i></button>
										</li>
									))}
								</ul>
								<div className="cart-total">
									{props.uid ? (
										<>
											<p>Total</p>
											<p>{formatCurrency(getCartTotal(props.items))}</p>
										</>
									) : null }
									<Link to="/checkout" onClick={props.close} className="link-primary link-outline">
										{props.uid ? "Checkout" : "Review Quote Request"}
									</Link>
								</div>
							</React.Fragment>
						) : <p className="empty-basket">Your basket is empty!</p>
					}
				</div>
			</div>
		</OutsideClickHandler>
	);
}

const mapStateToProps = (state, ownProps) => ({
	items: (
		ownProps.uid
			? Object.keys(
					state.firestore.data?.users?.[ownProps.uid]?.cart ?? {}
				)
					.filter(k => !!state.firestore.data.users[ownProps.uid].cart[k])
					.map(k => ({
						...state.firestore.data.users[ownProps.uid].cart[k],
						id: k
					})) || []
			: Object.entries(getLocalCart())
					.map(([key, value]) => ({
						...value,
						id: key
					}))
		)
});

const mapDispatchToProps = dispatch => ({
	updateQuantity: (item, qnt) => dispatch(updateQuantity(item, qnt))
});

export default compose(
	firestoreConnect((props) => (props.uid ? [
		{
			collection: 'users',
			doc: props.uid,
			subcollections: [{
				collection: 'cart',
				storeAs: "cart"
			}]
		}
	] : [])),
	connect(mapStateToProps, mapDispatchToProps)
)(MiniCart);
